import { render } from "./chatPage.vue?vue&type=template&id=13503041&scoped=true"
import script from "./chatPage.vue?vue&type=script&lang=js"
export * from "./chatPage.vue?vue&type=script&lang=js"

import "./chatPage.vue?vue&type=style&index=0&id=13503041&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dadao-im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13503041"]])

export default __exports__